import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [
    "modal", "membersList", "personInput", "personId", "roleSelect", "notes",
    "editModal", "editPersonName", "editPersonId", "editRoleSelect", "editNotes"
  ]
  static values = { projectId: Number }

  showAddModal() {
    this.modalTarget.classList.remove("hidden")
    this.personInputTarget.value = ""
    this.personIdTarget.value = ""
    this.roleSelectTarget.value = "team_member"
    if (this.hasNotesTarget) {
      this.notesTarget.value = ""
    }
    this.personInputTarget.focus()
  }

  hideAddModal() {
    this.modalTarget.classList.add("hidden")
  }

  async addMember() {
    const personId = this.personIdTarget.value
    const role = this.roleSelectTarget.value
    const notes = this.hasNotesTarget ? this.notesTarget.value : ""

    if (!personId) {
      alert("Please select a person")
      return
    }

    try {
      const response = await fetch(`/projects/${this.projectIdValue}/add_team_member`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "X-CSRF-Token": document.querySelector("[name='csrf-token']").content
        },
        body: JSON.stringify({ person_id: personId, role: role, notes: notes })
      })

      const data = await response.json()

      if (response.ok && data.success) {
        // Reload the page to show the updated team list
        window.location.reload()
      } else {
        alert(data.error || "Failed to add team member")
      }
    } catch (error) {
      console.error("Error adding team member:", error)
      alert("An error occurred. Please try again.")
    }
  }

  async removeMember(event) {
    const personId = event.currentTarget.dataset.personId
    
    if (!confirm("Remove this person from the project?")) {
      return
    }

    try {
      const response = await fetch(`/projects/${this.projectIdValue}/remove_team_member?person_id=${personId}`, {
        method: "DELETE",
        headers: {
          "X-CSRF-Token": document.querySelector("[name='csrf-token']").content
        }
      })

      const data = await response.json()

      if (response.ok && data.success) {
        // Remove the element from the DOM
        const memberElement = this.membersListTarget.querySelector(`[data-person-id="${personId}"]`)
        if (memberElement) {
          memberElement.remove()
        }
        
        // Check if list is empty
        const remainingMembers = this.membersListTarget.querySelectorAll("[data-person-id]")
        if (remainingMembers.length === 0) {
          this.membersListTarget.innerHTML = '<p class="text-sm text-slate-500 text-center py-4">No team members yet.</p>'
        }
      } else {
        alert(data.error || "Failed to remove team member")
      }
    } catch (error) {
      console.error("Error removing team member:", error)
      alert("An error occurred. Please try again.")
    }
  }

  async editMember(event) {
    console.log("editMember called", event)
    // Get personId from the data attribute
    const personId = event.currentTarget.dataset.personId
    console.log("personId:", personId)
    
    if (!personId) {
      console.error("No personId found")
      return
    }
    
    try {
      const response = await fetch(`/projects/${this.projectIdValue}/get_team_member?person_id=${personId}`, {
        headers: {
          "Accept": "application/json"
        }
      })

      if (!response.ok) {
        alert("Failed to load team member details")
        return
      }

      const data = await response.json()

      // Populate the edit modal
      this.editPersonNameTarget.textContent = data.person_name
      this.editPersonIdTarget.value = data.person_id
      this.editRoleSelectTarget.value = data.role
      this.editNotesTarget.value = data.notes || ""

      // Show the modal
      this.editModalTarget.classList.remove("hidden")
    } catch (error) {
      console.error("Error loading team member:", error)
      alert("An error occurred. Please try again.")
    }
  }

  hideEditModal() {
    this.editModalTarget.classList.add("hidden")
  }

  async saveMember() {
    const personId = this.editPersonIdTarget.value
    const role = this.editRoleSelectTarget.value
    const notes = this.editNotesTarget.value

    try {
      const response = await fetch(`/projects/${this.projectIdValue}/update_team_member?person_id=${personId}`, {
        method: "PATCH",
        headers: {
          "Content-Type": "application/json",
          "X-CSRF-Token": document.querySelector("[name='csrf-token']").content
        },
        body: JSON.stringify({ role: role, notes: notes })
      })

      const data = await response.json()

      if (response.ok && data.success) {
        // Reload the page to show updated info
        window.location.reload()
      } else {
        alert(data.error || "Failed to update team member")
      }
    } catch (error) {
      console.error("Error updating team member:", error)
      alert("An error occurred. Please try again.")
    }
  }

  viewPerson() {
    const personId = this.editPersonIdTarget.value
    if (personId) {
      window.location.href = `/people/${personId}`
    }
  }
}

